module.exports = {"master":{"setings":"Settings"}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/en/master.json
// module id = 548
// module chunks = 13